window.addEventListener("DOMContentLoaded", () => {
  const searchInput = document.querySelector(
    "#search-modal .search-form .inline-mini-form input"
  );

  searchInput.addEventListener("keyup", (event) => search(event.target.value));


  const queryString = window.location.search;

  if(queryString !== ''){
    const params = new URLSearchParams(queryString);
    const searchTerm = params.get('q')
    if(searchTerm){
      setTimeout(()=> {
        search(searchTerm)
      },100)
    }
  }
});

const debounce = (func, timeout = 300)  => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      func.apply(this, args);
    }, timeout);
  };
}

const search = debounce(async (searchTerm) => {
  const predictiveSearch = document.querySelector('.predictive-search')
  const suggestedCollection = document.querySelector('.suggested-collection')

  if (searchTerm) {
    suggestedCollection.style.opacity = '0'
    setTimeout(() => {
      suggestedCollection.classList.add('hidden')
    }, 150)
    predictiveSearch.classList.remove('active')
    setTimeout(() => {
      predictiveSearch.innerHTML = `<span class="text-center">loading results...</span>`
      predictiveSearch.classList.add('active')
    },150)
    
    fetch(`/search/suggest.json?q=${searchTerm}`)
    .then((response) => response.json())
    .then((data) => {
      const searchResults = data?.resources?.results;
      predictiveSearch.classList.remove('active')
      setTimeout(() => {
        populateResults(searchResults, predictiveSearch, searchTerm)
      }, 100)
    })
    .catch((error) => {
      console.error("Error fetching data:", error);
    });
  } else {
    predictiveSearch.classList.remove('active')
    suggestedCollection.classList.remove('hidden')
    setTimeout(()=> {
      suggestedCollection.style.opacity = '1'
      predictiveSearch.innerHTML = ``
    }, 150)
  }
}, 500);

const populateResults = (searchResults, predictiveSearch, searchTerm) => {
  predictiveSearch.innerHTML = ''
  
  if (searchResults.products.length) {
    predictiveSearch.insertAdjacentHTML('beforeend', '<div class="product-results"></div>')

    const productResults = predictiveSearch.querySelector('.product-results')

    productResults.insertAdjacentHTML('beforeend', '<h2>Products</h2>')
    productResults.insertAdjacentHTML('beforeend', '<ul class="predictive-search-results"></ul>')
    const searchResultsList = productResults.querySelector('.predictive-search-results')

    searchResults.products.forEach(product => {
      const {featured_image} = product
      if (parseFloat(product.price_min) < parseFloat(product.compare_at_price_min)) {
        searchResultsList.insertAdjacentHTML('beforeend', `<li>
          <a class="product-grid-item" href="${product.url}">
          <img loading="lazy" src="${featured_image.url}" alt="${featured_image.alt}" width="${featured_image.width}" height="${featured_image.height}" />
          <span class="product-info">
            <h3>${product.title}</h3>
            <span class="price sale-price">$${product.price_min}</span>
            <span class="price compare-price">$${product.compare_at_price_min}</span>
          </span
        </a>
      </li>`)
      } else {
        searchResultsList.insertAdjacentHTML('beforeend', `<li>
          <a class="product-grid-item" href="${product.url}">
          <img loading="lazy" src="${featured_image.url}" alt="${featured_image.alt}" width="${featured_image.width}" height="${featured_image.height}" />
          <span class="product-info">
            <h3>${product.title}</h3>
            <span class="price">$${product.price_min}</span>
          </span
        </a>
      </li>`)
      }
    });
    productResults.insertAdjacentHTML('beforeend', `<a href="/search?type=product&5Bprefix%5D=last&q=${searchTerm}" class="view-result-button">View all for "${searchTerm}"</a>`)
  }  

  if (searchResults.collections.length || searchResults.queries.length || searchResults.pages.length) {
    predictiveSearch.insertAdjacentHTML('beforeend', '<div class="additional-results"></div>')
    const additionalResults = predictiveSearch.querySelector('.additional-results')
    if(searchResults.queries.length) {
      additionalResults.insertAdjacentHTML('beforeend', '<h2>Suggestions</h2>')
      additionalResults.insertAdjacentHTML('beforeend', '<ul class="suggestions-list"></ul>')
      const suggestionsList = additionalResults.querySelector('.suggestions-list')
      searchResults.queries.forEach(suggestion => {
        suggestionsList.insertAdjacentHTML('beforeend', `<li><a href="${suggestion.url}">${suggestion.text}</a></li>`)
      })

    }

    if(searchResults.collections.length) {
      additionalResults.insertAdjacentHTML('beforeend', '<h2>Collections</h2>')   
      additionalResults.insertAdjacentHTML('beforeend', '<ul class="collections-list"></ul>')
      const collectionsList = additionalResults.querySelector('.collections-list')
      searchResults.collections.forEach(collection => {
        collectionsList.insertAdjacentHTML('beforeend', `<li><a href="${collection.url}">${collection.title}</a></li>`)
      })

    }

    if(searchResults.pages.length) {
      additionalResults.insertAdjacentHTML('beforeend', '<h2>Pages</h2>')   
      additionalResults.insertAdjacentHTML('beforeend', '<ul class="pages-list"></ul>')
      const pagesList = additionalResults.querySelector('.pages-list')
      searchResults.pages.forEach(page => {
        pagesList.insertAdjacentHTML('beforeend', `<li><a href="${page.url}">${page.title}</a></li>`)
      })

    }
  }
  
  if (!searchResults.products.length && !searchResults.collections.length && !searchResults.queries.length && !searchResults.pages.length) {
    predictiveSearch.innerHTML = `<span class="text-center">No Products Found for "${searchTerm}"</span`
  }

  predictiveSearch.classList.add('active')
}